import { render } from "./Recommended.vue?vue&type=template&id=6eb4cfb5&scoped=true"
import script from "./Recommended.vue?vue&type=script&lang=js"
export * from "./Recommended.vue?vue&type=script&lang=js"

import "./Recommended.vue?vue&type=style&index=0&id=6eb4cfb5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6eb4cfb5"

export default script